import { bootstrapApplication } from '@angular/platform-browser';

import { App } from './app/app';
import { appConfig } from './app/core/config/app.config';
import { recordError } from './app/core/error/diagnostics';

bootstrapApplication(App, appConfig).catch((error) => {
  recordError('bootstrap', error);
});
